export default __webpack_public_path__ + "static/media/submission-success.e4faca28.svg";